import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { RTLProps } from '@/shared/prop-types/ReducerProps';

export const AnnouncementsColumns = [
  {
    id: 'announcementSelect',
    label: 'Select',
    disablePadding: true,
  },
  {
    id: 'announcement',
    label: 'Announcement',
    disablePadding: true,
  },
  {
    id: 'createdDate',
    label: 'Created Date',
    disablePadding: true,
  },
  {
    id: 'expiryDate',
    label: 'Expiry Date',
    disablePadding: true,
  },
  {
    id: 'isPublic',
    label: 'Is Public',
    disablePadding: true,
  },
  {
    id: 'Action',
    label: 'Action',
  },
];

const createSortHandler = (property, onRequestSort) => (event) => {
  onRequestSort(event, property);
};

const AnnouncementsTableColumns = ({ order, orderBy, rtl, onRequestSort }) => (
  <Fragment>
    <TableRow>
      {AnnouncementsColumns.map((row) => (
        <TableCell
          className="material-table__cell material-table__cell--sort material-table__cell-center"
          key={row.id}
          align={row.id == 'title' ? 'left' : 'center'}
          padding={row.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === row.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === row.id}
            direction={order}
            onClick={createSortHandler(row.id, onRequestSort)}
            className="material-table__sort-label"
            dir="ltr"
          >
            <b>{row.label}</b>
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  </Fragment>
);

AnnouncementsTableColumns.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rtl: RTLProps.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(AnnouncementsTableColumns);
